import React from 'react';

function ConfirmModal({ isOpen, onClose, onConfirm, message }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content confirm-modal">
                <div className="modal-header">
                    <h2>Confirmar acción</h2>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    <p>{message}</p>
                </div>
                <div className="modal-footer">
                    <button className="cancel-button" onClick={onClose}>Cancelar</button>
                    <button className="confirm-button" onClick={onConfirm}>Confirmar</button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal;

